var lists_default = {
  "fontElementMap": "_9mZ58",
  "orderedlist": "PXzXF",
  "bulletedlist": "OClnj",
  "listItem": "WhyNw"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
